module.exports = __webpack_public_path__ + "static/img/btn-avatar.0d7256e0.webp";